import { useContext } from 'react';

import { AuthContext } from '@/hooks/AuthContext';

export const useAuth = () => useContext(AuthContext);
